import React from 'react';
import { toast } from "react-toastify";
import CKEditor from '../../../ckeditor/safe-ckeditor';
import { IoInformation } from "react-icons/io5";
import { BsBoxArrowInRight } from "react-icons/bs";
import Tooltip from 'react-bootstrap/Tooltip';
import { Button, Form } from 'react-bootstrap';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import ArrowBackOutlinedIcon from '@material-ui/icons/ArrowBackOutlined';
import ArrowForwardOutlinedIcon from '@material-ui/icons/ArrowForwardOutlined';

import axios from '../../../../axios';
import apiError from '../../../../error';
import AddURL from '../../../create-template/import-site/add-url';
import ImportSite from '../../../create-template/import-site/import-site';
import Loader from '../../../loader/loader';
import Spinner from '../../../spinner/spinner';
import ImportLandingFromStore from '../../../create-template/pages/import-landing-from-store'
import HtmlPreviewEditor from '../html-preview-editor';
const NO_LANDING_URL = '-1';

export default class Pages extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            url: '',
            html: '',
            addURL: '',
            show: false,
            importUrl: '',
            loading: false,
            loadHtml: false,
            landing_urls: [],
            showAddURL: false,
            loadingImport: false,
            capture_passwords: 0,
            capture_credentials: 0,
            showImportModal: false,
            htmlKey: 1,
            landing_url: NO_LANDING_URL,
        }
    }

    componentDidMount = () => {
        this.initializePage();
        setTimeout(() => {
            this.setState({ htmlKey: this.state.htmlKey + 1 });
        }, 1500);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.pageId !== this.props.pageId) {
            this.initializePage();
        }
    }

    initializePage = () => {
        this.loadLandingUrls();
        if (this.props.pageId) {
            axios.get('/api/pages/' + this.props.pageId, {})
                .then(res => {
                    this.setState({
                        loadHtml: true,
                        html: res.data.page.html,
                        url: res.data.page.redirect_url,
                        capture_passwords: res.data.page.capture_passwords,
                        capture_credentials: res.data.page.capture_credentials,
                        landing_url: res.data.page.landing_url ? res.data.page.landing_url : NO_LANDING_URL,
                        htmlKey: this.state.htmlKey + 1,
                    })
                })
                .catch(err => {
                    apiError(err)
                })
        } else {
            this.setState({ loadHtml: true })
        }
    }

    /**
     * `/api/pages/url` is paginated (default limit ~10). Fetch every page and merge so the dropdown lists all URLs.
     */
    loadLandingUrls = () => {
        this.setState({ loading: true });
        const pageSize = 250;
        const maxPages = 200;

        const fetchPage = (page, accumulated) => {
            axios
                .get("/api/pages/url", {
                    params: {
                        status: true,
                        page,
                        limit: pageSize,
                        search: "",
                    },
                })
                .then((res) => {
                    const batch = Array.isArray(res.data.landing_urls) ? res.data.landing_urls : [];
                    const merged = accumulated.concat(batch);
                    const totalCount =
                        res.data.count != null ? Number(res.data.count) : null;
                    const gotFullCount = totalCount != null && !Number.isNaN(totalCount) && merged.length >= totalCount;
                    const lastPage = batch.length < pageSize || gotFullCount || page >= maxPages;

                    if (lastPage) {
                        this.setState({ loading: false, landing_urls: merged });
                    } else {
                        fetchPage(page + 1, merged);
                    }
                })
                .catch((error) => {
                    this.setState({ loading: false });
                    apiError(error);
                });
        };

        fetchPage(1, []);
    }

    handleChange = (e) => {
        this.setState({ html: e.editor.getData() });
    }

    hasLandingPage = () => {
        const url = this.state.landing_url;
        return !!(url && url !== NO_LANDING_URL && (this.state.html || '').trim());
    }

    /* Main "Go To Next" handler. Landing page is optional:
         - nothing selected ("Select Landing URL") and no page saved yet -> just advance,
           leaving pageId null so every click goes straight to the awareness page;
         - a URL chosen, or an existing page being cleared back to "none" -> persist it
           (handleCreateTemplate maps the "-1" placeholder to NULL). */
    handleGoNext = () => {
        if (this.state.landing_url === NO_LANDING_URL && !this.props.pageId) {
            this.props.handleTabChange('next');
            return;
        }
        this.handleCreateTemplate();
    }

    handleCreateTemplate = () => {
        const data = {
            html: this.state.html,
            redirect_url: this.state.url,
            /* "-1" means "no landing page" -- store NULL, never the sentinel */
            landing_url: this.state.landing_url === NO_LANDING_URL ? null : this.state.landing_url,
            campaignTemplateId: this.props.campaignTemplateId,
            capture_passwords: this.state.capture_passwords ? true : false,
            capture_credentials: this.state.capture_credentials ? true : false,
        }

        this.setState({ loading: true })
        if (this.props.pageId) {
            axios.patch('/api/pages/' + this.props.pageId, data)
                .then(res => {
                    this.setState({ loading: false })
                    this.props.handleTabChange('next');
                })
                .catch(error => {
                    apiError(error);
                    this.setState({ loading: false })
                })
        } else {
            axios.post('/api/pages/', data)
                .then(res => {
                    this.setState({ loading: false })
                    this.props.handleTabChange('next');
                    this.props.handlePageId(res.data.page.id);
                    toast.success('Landing Page Created Successfully')
                })
                .catch(error => {
                    apiError(error)
                    this.setState({ loading: false })
                })
        }
    }

    handleImportSite = async () => {
        if (this.state.importUrl.length === 0) {
            toast.error("Please Enter URL");
            return;
        }
        await this.setState({ loadingImport: true });
        axios.get('/api/import/site', { params: { url: this.state.importUrl } })
            .then(res => {
                this.setState({ 
                    html: res.data.html, 
                    loadingImport: false, 
                    htmlKey: this.state.htmlKey + 1 
                });
                this.handleImportSiteModal();
            })
            .catch(err => {
                apiError(err)
                this.setState({ loadingImport: false });
            })
    }

    handleImportSiteModal = () => {
        this.setState({ show: !this.state.show });
    }

    handleContent = (e) => {
        this.setState({ importUrl: e.target.value })
    }

    validURL = (str) => {
        var pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
            '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
            '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
            '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
            '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
            '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator
        return !!pattern.test(str);
    }

    handleAddURL = () => {
        if (this.state.addURL.length === 0) {
            toast.error("Please Enter Landing URL");
            return;
        } else if (!this.validURL(this.state.addURL)) {
            toast.error("Please Enter Valid Landing URL");
            return;
        } else {
            axios.post('/api/pages/url', { url: this.state.addURL })
                .then(res => {
                    this.loadLandingUrls();
                    this.setState({ showAddURL: false })
                    toast.success('Landing URL Added Successfully')
                })
                .catch(err => {
                    apiError(err)
                })
        }
    }

    getHtml = () => this.state.html || "";
    applyGeneratedHtml = (html) => {
        if (!html) return;
        this.setState({
            html,
            loadHtml: true,
            htmlKey: this.state.htmlKey + 1,
        });
    }

    //i write this function so that this can update the state for the data that is taking in
    handleLoadSelectedStoreTemplateHtml = (html, name, capture_credentials, capture_passwords, landing_url) => {
        this.setState({
            html,
            capture_passwords,
            capture_credentials,
            htmlKey: this.state.htmlKey + 1,
            landing_url
        }, () => {
            toast.success(`Template "${name}" Loaded Successfully`);
        });
    }

    render() {
        return (
            <>
                <div className="email-template-wrap">
                    <div className='rightSectionHeader'>
                        <div className="row justify-content-between align-items-center">
                            <div className="col-md-3 tab-right-header">
                                <h6>Landing Page</h6>
                                <p>Configure page shown after email click</p>
                            </div>
                            <div className="col-md-9 text-right">
                                <OverlayTrigger
                                    placement='top'
                                    overlay={<Tooltip id='top'>Import a landing page from our template store</Tooltip>}>
                                    <Button variant="secondary" type="button" onClick={() => this.setState({ showImportModal: true })} className="mr-2">Import From Store</Button>
                                </OverlayTrigger>
                                    <OverlayTrigger
                                        placement='top'
                                          overlay={<Tooltip id='top'>Enter the URL of an existing landing page to import</Tooltip>}>
                                      <Button variant="primary" type="button" onClick={this.handleImportSiteModal} className="mr-2"><BsBoxArrowInRight className='btn-icon' />Import From URL</Button>
                                </OverlayTrigger>
                            </div>
                        </div>
                    </div>
                    <div className='setMarginCss'>
                        <Form>
                            <Form.Group className='checkBoxWrap'>
                                <Form.Label>Landing Page Url
                                    <OverlayTrigger
                                        placement='top'
                                        overlay={<Tooltip id='top'>Add URL to redirect the users at your preferred landing page</Tooltip>}>
                                        <IoInformation className="tooltip-icon"></IoInformation>
                                    </OverlayTrigger>
                                </Form.Label>

                                <Form.Control as="select" value={this.state.landing_url} onChange={e => this.setState({ landing_url: e.target.value })}>
                                    <option key={'select-landing-url'} value={NO_LANDING_URL}>Select Landing URL</option>
                                    {this.state.landing_urls.map((url, index) => {
                                        return <option key={index} disabled={!url.isValid} value={url.name}>{url.name}</option>
                                    })}
                                </Form.Control>
                                <Form.Text className="text-muted">
                                    {this.hasLandingPage()
                                        ? ""
                                        : "This step is optional."}
                                </Form.Text>

                            </Form.Group>
                        </Form>
                    </div>
                    <div className='setMarginCss'>
                        {this.state.loadHtml ?
                            <HtmlPreviewEditor
                                label="Landing Page"
                                html={this.state.html}
                                promptBar={this.props.promptBar}
                            >
                                <CKEditor
                                    editorUrl={`${process.env.REACT_APP_API_URL}/staticpra/ckeditor/ckeditor.js`}
                                    config={{
                                        allowedContent: true,
                                        fullPage: true
                                    }}
                                    key={this.state.htmlKey}
                                    initData={this.state.html}
                                    onChange={this.handleChange}
                                ></CKEditor>
                            </HtmlPreviewEditor>: null
                        }
                    </div>
                    {
                        this.props.attack_type_name === "Ransomware" ? null : (
                            <React.Fragment>
                            <div className='checkBoxWrap setMarginCss ml-1'>
                            <Form.Group controlId="formBasicCheckbox" className='mb-0'>
                                <Form.Check type="checkbox"
                                    label="Capture Username/Email"
                                    checked={this.state.capture_credentials}
                                    onChange={e => this.setState({ capture_credentials: !this.state.capture_credentials })} />
                            </Form.Group>
                        </div>
                        <div className='checkBoxWrap setMarginCss ml-1'>
                            <Form.Group controlId="formBasicCheckbox2" className="mb-0 d-flex">
                                <Form.Check type="checkbox" checked={this.state.capture_passwords} onChange={e => this.setState({ capture_passwords: !this.state.capture_passwords })} label="Capture Password" />
                                <OverlayTrigger
                                    placement='top'
                                    overlay={<Tooltip id='top'>Allows you to capture the credentials of the user who has been redirected to the landing page</Tooltip>}>
                                    <IoInformation className="tooltip-icon"></IoInformation>
                                </OverlayTrigger>
                            </Form.Group>
                        </div>
                            
                        </React.Fragment>
                        )
                    }
                   

                    {/* <div className='checkBoxWrap setMarginCss ml-1'>
                        <Form.Group controlId="formBasicCheckbox3" className="mb-0 d-flex">
                            <Form.Check type="checkbox" checked={this.state.auto_instant_awarenes} onChange={e => this.setState({ auto_instant_awarenes: !this.state.auto_instant_awarenes })} label="Auto-Instant Awareness" />
                            <OverlayTrigger
                                placement='top'
                                overlay={<Tooltip id='top'>Select this to redirect the user to an awareness page as soon as they submit their credentials and password on the landing page</Tooltip>}>
                                <IoInformation className="tooltip-icon " ></IoInformation>
                            </OverlayTrigger>
                        </Form.Group>
                    </div>

                    {!this.state.auto_instant_awarenes ?
                        <Form.Group className="col-md-12 pl-0">
                            <Form.Label>Redirect URL/Link to Instant Awareness Page</Form.Label>
                            <Form.Control type="text" value={this.state.url} onChange={e => this.setState({ url: e.target.value })} placeholder="https://awareness.threatcop.ai/abc.html" />
                        </Form.Group> : ''
                    } */}
                </div>

                <div className="mt-2">
                    <div className="footer-wrapper justify-content-end d-flex">
                        <Button className="btn closeBtn mr-2" onClick={e => this.props.handleTabChange('prev')}><ArrowBackOutlinedIcon className="btn-icon"></ArrowBackOutlinedIcon> Previous</Button>
                        <Button variant="success" disabled={this.state.loading} type="button" onClick={this.handleGoNext}><Spinner loading={this.state.loading}></Spinner><ArrowForwardOutlinedIcon className={this.state.loading ? "btn-icon d-none" : "btn-icon"}></ArrowForwardOutlinedIcon> Go To Next</Button>
                    </div>
                </div>

                <ImportSite
                    show={this.state.show}
                    importUrl={this.state.importUrl}
                    handleContent={this.handleContent}
                    handleImportSite={this.handleImportSite}
                    handleImportSiteModal={this.handleImportSiteModal}
                ></ImportSite>
                <ImportLandingFromStore
                    showImportModal={this.state.showImportModal}
                    handleClose={e => this.setState({ showImportModal: false })}
                    handleLoadSelectedStoreTemplateHtml={this.handleLoadSelectedStoreTemplateHtml}
                ></ImportLandingFromStore>
                <AddURL
                    addURL={this.state.addURL}
                    show={this.state.showAddURL}
                    handleSubmit={this.handleAddURL}
                    handleAddURL={e => this.setState({ showAddURL: false })}
                    handleContent={e => this.setState({ addURL: e.target.value })}
                ></AddURL>
                {this.state.loadingImport ? <Loader></Loader> : null}
            </>
        )
    }
}
